import { num } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

const STATUS = {
  manca: { label: "Manca", cls: "border-rose-500/50 text-rose-400" },
  eccesso: { label: "In eccesso", cls: "border-amber-500/50 text-amber-400" },
  in_linea: { label: "In linea", cls: "border-emerald-500/50 text-emerald-400" },
};

const Bar = ({ pct, cls }) => (
  <div className="h-1.5 w-full rounded-full bg-secondary"><div className={`h-1.5 rounded-full ${cls}`} style={{ width: `${Math.min(pct, 100)}%` }} /></div>
);

export const SaleStockCompare = ({ title, rows, testid }) => (
  <div data-testid={testid}>
    <p className="mb-2 font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">{title}</p>
    <div className="space-y-2.5">
      {rows.slice(0, 15).map((r) => (
        <div key={r.name} data-testid={`${testid}-${r.name}`}>
          <div className="mb-1 flex items-center justify-between gap-2 text-xs">
            <span className="truncate font-medium">{r.name}</span>
            <span className="flex shrink-0 items-center gap-2 text-muted-foreground">
              saldi {r.demand_pct}% · magazzino {r.stock_pct}% ({num(r.stock)} pz)
              <Badge variant="outline" className={`text-[10px] ${STATUS[r.status].cls}`} data-testid={`${testid}-${r.name}-status`}>{STATUS[r.status].label}</Badge>
            </span>
          </div>
          <div className="space-y-0.5">
            <Bar pct={r.demand_pct} cls="bg-primary" />
            <Bar pct={r.stock_pct} cls="bg-muted-foreground/60" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
